module.exports = __webpack_public_path__ + "media/icons/smartsearch/materials/rg_pg-f8ca0afe5d37fd179c542f7080fb47ee.png";